import { DropdownOption, PartnerType } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getPartnerTypeOptions: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<DropdownOption<PartnerType>[]> = (fetchContext, accessToken) => fetch(`${fetchContext.baseUrl}/api/partner-types`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<DropdownOption<PartnerType>[]>(fetchContext.errorStore, response, 'get partner type options'));
